import HotelsCard from './HotelsCard';

export default HotelsCard;
